import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AiFillDelete } from "react-icons/ai";

//////
import { GetMethod, PutMethod, DeleteMethod } from "../../helper/Api";
import PageChange from "../../pageChange";
import Layout from "../../component/Layout/Layout";
import Card from "../../component/Layout/theme/card";
import { Input } from '../../component/form/input'
import { validateForm } from "../../helper/helper";
import { LoginData } from "../../redux/featuer/user/userSlice";
import toast from "react-hot-toast";
import { QRCode } from "react-qrcode-logo";
import CustomModal from "../../component/Modal/custom";


const Profile = () => {
    const [isDataLoad, setIsDataLoad] = useState(false);
    ///redux
    const { user, token, login } = useSelector((item) => item.user);


    const dispatch = useDispatch();

    ///form data
    const [names, setNames] = useState(user.name);
    const [phone, setPhone] = useState(0);
    const [personalizedSite, setPersonalizedSite] = useState("");
    const [personalizedAccess, setPersonalizedAccess] = useState(false);

    const [userName, setUserName] = useState("");



    ///logo
    const [showModalRemove, setShowModalRemove] = useState(false);
    const [userLogo, setUserLogo] = useState("");
    const [preview, setPreview] = useState("");
    const [showImage, setShowImage] = useState("")
    const qrSize = 1000;



    useEffect(() => {
        const getUser = async () => {
            try {
                var url = `/api/user/me/`;
                const res = await GetMethod({ url: url, token: token });
                if (res.status === "success") {
                    dispatch(LoginData(res.data));
                    setShowImage(res.data.logo);
                    setPreview(res.data.logo ? `${process.env.REACT_APP_SERVER + res.data.logo}` : "")
                    setPhone(res.data.phone);
                    setUserName(res.data.username);
                    setPersonalizedSite(res.data.personalized_site)
                    setPersonalizedAccess(res.data.personalized_access)
                }
            } catch (error) {
                toast.error(error);
            }
        }

        document.title = "ویرایش پروفایل";
        if (!login) {
            document.location.href = "/login"
        } else {
            getUser();
            setIsDataLoad(true);
        }
    }, [dispatch, login, token]);


    const submitForm = async (e) => {
        //refresh nashodn site bade click
        e.preventDefault();
        setIsDataLoad(false)

        if (validateForm(e)) {
            const formData = new FormData();
            formData.append("logo", userLogo)
            formData.append("name", names);
            formData.append("personalized_site", personalizedSite);
            var url = `/api/user/${user._id}`;
            PutMethod(
                { url: url, body: formData, token: token },
                (res) => {
                    if (res.status === "success") {
                        setIsDataLoad(true)
                        toast.success("اطلاعات بروزرسانی شد");
                        dispatch(LoginData(res.data));
                    }
                },
                (error) => {
                    setIsDataLoad(true)
                    toast.error(error.response.data.msg);
                }
            );
        }
    };

    const deleteImage = async () => {
        var url = `/api/user/logo/${user._id}`
        await DeleteMethod(
            { url: url, token: token },
            (res) => {
                console.log("res", res);
                if (res.status === "success") {
                    setPreview("")
                    setShowImage("")
                    toast.success("عکس با موفقیت حذف شد")
                }
            },
            (error) => {
                console.log("error", error);
                toast.error(error.response.data.msg);
            }
        );


    }



    return (
        <>
            {isDataLoad ? (
                <>
                    <Layout >
                        <Card >
                            <form onSubmit={submitForm} className="p-5 mb-20 bg-white rounded-lg shadow-md" >
                                <div className="">
                                    <div className="relative mt-3 ">
                                        <Input
                                            className={'w-90'}
                                            placeholder="نام مجموعه"
                                            type="text"
                                            value={names}
                                            id={"name"}
                                            name={"name"}
                                            autoComplete={"off"}
                                            requiredir={true}
                                            onChange={(e) => setNames(e.target.value)}
                                        />
                                    </div>
                                    <div className="relative mt-3 ">
                                        <Input
                                            className={'w-90'}
                                            placeholder="نام کاربری "
                                            type="text"
                                            value={userName}
                                            id={"userName"}
                                            name={"userName"}
                                            autoComplete={"off"}
                                            disabled={true}
                                        />
                                    </div>

                                    <div className="relative mt-3">
                                        <Input
                                            className={'w-90'}
                                            placeholder="شماره تلفن"
                                            type="text"
                                            value={phone}
                                            id={"name"}
                                            name={"name"}
                                            autoComplete={"off"}
                                            disabled={true}
                                        />
                                    </div>

                                    {personalizedAccess &&
                                        (
                                            <div className="relative mt-3">
                                                <Input
                                                    className={'w-90'}
                                                    placeholder="سایت شخصی"
                                                    type="text"
                                                    value={personalizedSite}
                                                    onChange={(e) => setPersonalizedSite(e.target.value)}
                                                    id={"personalized_site"}
                                                    name={"personalized_site"}
                                                    autoComplete={"off"}
                                                />
                                            </div>
                                        )
                                    }

                                    <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-2">
                                        <div>
                                            <label className="inline-block mt-4 mb-2 text-gray-500">بارگذاری لوگو</label>
                                            <div className="flex !h-48">
                                                <label className="flex flex-col border-4 border-gray-200 border-dashed hover:bg-blue-100 hover:border-blue-300">
                                                    <div className="flex flex-col m-auto items-center justify-center ">
                                                        {showImage && showImage.length > 1 ? (
                                                            <div className="relative" >
                                                                <img
                                                                    crossOrigin="anonymous"
                                                                    src={`${process.env.REACT_APP_SERVER + showImage}`}
                                                                    alt={'Profile logo'}
                                                                    className={`free-image h-44 min-h-40`}
                                                                />

                                                                <div className="absolute left-0 mr-4 text-red-500 top-1">
                                                                    <AiFillDelete className="relative z-40 cursor-pointer" size={24} color="black" onClick={() => { setShowModalRemove(true) }} />
                                                                </div>
                                                            </div>
                                                        ) :
                                                            <>
                                                                {preview && preview.length > 0 ? (
                                                                    <div className="relative" >
                                                                        <img
                                                                            crossOrigin="anonymous"
                                                                            src={preview}
                                                                            alt={'Profile logo'}
                                                                            className={`free-image h-44 min-h-40`}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex items-center mt-10 ">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-gray-400 group-hover:text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                                                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                                        </svg>
                                                                        <p className="pt-1 px-1 text-sm tracking-wider text-gray-400 group-hover:text-gray-600">
                                                                            انتخاب لوگو مجموعه </p>
                                                                    </div>
                                                                )}
                                                                <input
                                                                    type="file"
                                                                    onChange={(e) => {
                                                                        if (e.target.files.length !== 0) {
                                                                            setPreview(
                                                                                URL.createObjectURL(e.target.files[0])
                                                                            );
                                                                        }
                                                                        setUserLogo(e.target.files[0]);
                                                                    }}
                                                                    accept="image/*"
                                                                    className="opacity-0"
                                                                />
                                                            </>
                                                        }
                                                    </div>

                                                </label>
                                            </div>
                                        </div>

                                        {preview && (
                                            <div>
                                                <label className="inline-block mt-4 mb-2 text-gray-500">پیش نمایش</label>
                                                <div className="my-auto">
                                                    <div className='canvas-qr-card'>
                                                        <QRCode
                                                            value={`${process.env.REACT_APP_CLIENT}`}
                                                            size={qrSize}
                                                            logoImage={preview}
                                                            fgColor={"#000"}
                                                            removeQrCodeBehindLogo={false}
                                                            quietZone={5}
                                                            eyeRadius={
                                                                [
                                                                    { // top/left eye
                                                                        outer: [10, 10, 0, 10],
                                                                        inner: [0, 10, 10, 10],
                                                                    },
                                                                    [10, 10, 10, 0], // top/right eye
                                                                    [10, 0, 10, 10], // bottom/left
                                                                ]
                                                            }
                                                            enableCORS={true}
                                                            logoWidth={qrSize / 1.6}
                                                            logoHeight={qrSize / 1.6}
                                                            logoOpacity={0.4}
                                                            ecLevel={'Q'}
                                                            qrStyle={"dots"} // squares
                                                            id={"QR"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>


                                <div className="relative flex justify-center mt-4">
                                    <button
                                        className="h-10 text-white bg-green-500 rounded-lg w-52 "
                                        type="submit"
                                        id="SubmitProfile"
                                    >
                                        ویرایش
                                    </button>
                                </div>
                            </form>
                        </Card>

                        <CustomModal
                            showModal={showModalRemove}
                            setShowModal={setShowModalRemove}
                            title="حذف؟"
                            html={
                                <p className="w-96">
                                    آیا مطمئن به حذف هستید؟
                                    <br />
                                    <span>درصورت حذف دیگر قابل بازگردانی نیست!</span>
                                </p>
                            }
                            buttons={[
                                < button
                                    key="cancel_remove_btn"
                                    onClick={() => { setShowModalRemove(false) }}
                                    className={`w-full bg-gray-500 hover:shadow-lg text-white active:bg-gray-600 font-bold uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                                    type="button"
                                >
                                    انصراف
                                </button >,
                                < button
                                    key="remove_btn"
                                    onClick={() => { setShowModalRemove(false); deleteImage() }}
                                    className={`w-full bg-red-500 hover:shadow-lg text-white active:bg-red-600 font-bold uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
                                    type="button"
                                >
                                    حذف
                                </button >
                            ]}
                        />
                    </Layout>


                </>
            ) : (
                <PageChange />
            )
            }
        </>


    )
}


export default Profile;